<template>
  <layout>
    <template v-slot:header>
      <AppHead title="Users" />
      <div class="d-flex align-items-center mb-2">
        <h2 class="m-0">Users</h2>
        <jet-button class="btn-short ml-2" icon="fas fa-user" :goesTo="route('users.create')">Create User</jet-button>
      </div>
      <BreadCrumbs activeItem="Users" :crumbs="{ home: 'Dashboard' }"/>
      <flash-messages />
    </template>
    
    <template v-slot:default>
      <div class="table-responsive">
        <table class="table table-sm table-striped tbody-border">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th colspan="2">Role</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td>
                <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500 text-nowrap" :href="route('users.edit', user.id)">
                  <img v-if="user.photo" class="block w-5 h-5 rounded-full mr-2 -my-2" :src="user.photo" />
                  {{ user.first_name }} {{ user.last_name }}
                  <icon v-if="user.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
                </inertia-link>
              </td>
              <td>
                <inertia-link class="px-6 py-4 flex items-center" :href="route('users.edit', user.id)" tabindex="-1">
                  <Email v-model="user.email" />
                </inertia-link>
              </td>
              <td>
                <inertia-link class="px-6 py-4 flex items-center m-text-nowrap" :href="route('users.edit', user.id)" tabindex="-1">
                  {{ user.role.display_name }}
                </inertia-link>
              </td>
              <td class="d-flex justify-content-end pr-5">
                <jet-button class="btn-short text-nowrap nav-icon" :goesTo="route('users.edit', user.id)" icon="fas fa-edit">Edit</jet-button>
              </td>
            </tr>
          </tbody>
          <tr v-if="users.length === 0">
            <td class="border-t px-6 py-4" colspan="4">No users found.</td>
          </tr>
        </table>
      </div>
    </template>
  </layout>
</template>

<script>
  import Icon from '@/Shared/Icon'
  import pickBy from 'lodash/pickBy'
  import Layout from '@/Shared/Admin/Layout'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import SearchFilter from '@/Shared/SearchFilter'
  import FlashMessages from '@/Shared/FlashMessages'
  import BreadCrumbs from '@/Shared/BreadCrumbs'

  export default {
    components: {
      Icon,
      SearchFilter,
      Layout,
      FlashMessages,
      BreadCrumbs
    },
    props: {
      users: Array,
      filters: Object,
    },
    data() {
      return {
        form: {
          search: this.filters.search,
          role: this.filters.role,
          trashed: this.filters.trashed,
        },
      }
    },
    watch: {
      form: {
        handler: throttle(function() {
          let query = pickBy(this.form)
          this.$inertia.replace(this.route('users', Object.keys(query).length ? query : { remember: 'forget' }))
        }, 150),
        deep: true,
      },
    },
    methods: {
      reset() {
        this.form = mapValues(this.form, () => null)
      },
    },
  }
</script>
